import { ref } from 'vue'
// Import your toast library here. Example:
import { toast } from 'vue-sonner'


export function useApiAction(apiAction, options = {}) {
  const loading = ref(false)
  const validationErrors = ref(null)
  const execute = async (...args) => {
    loading.value = true
    validationErrors.value = null

    try {
      // Execute the API call passing any arguments provided
      const response = await apiAction(...args)

      // Handle Success Callback
      if (options.onSuccess) {
        options.onSuccess(response)
      }

      return response
    }
    catch (e) {
      console.error('API Error:', e)

      // 1. Handle Validation Errors
      if (e.response?.data?.errors) {
        validationErrors.value = e.response.data.errors
      }
      // 2. Handle Generic Message (Toast)
      else if (e.response?.data?.message) {
        toast.error(e.response.data.message)
        console.warn('Toast:', e.response.data.message)
      }

      // Handle generic Error Callback if needed
      if (options.onError) {
        options.onError(e)
      }
    }
    finally {
      loading.value = false
    }
  }

  // Helper to check if a field has validation errors
  // null if undefined, false if validation failed, true if passes
  const validationResult = (field) => {
    if(validationErrors.value && validationErrors.value[field]) {
      return false;
    }
    else if(validationErrors.value && !validationErrors.value) {
      return true;
    }
    return null;
  }
  const getError = (field) => {
    if (!validationErrors.value || !validationErrors.value[field]) {
      return null
    }
    const error = validationErrors.value[field]
    // Handle both Array (Laravel style) and String formats
    return Array.isArray(error) ? error[0] : error
  }

  // NEW: Helper to clear a specific error when user starts typing
  const clearError = (field) => {
    if (validationErrors.value && validationErrors.value[field]) {
      delete validationErrors.value[field]
    }
  }

  return {
    loading,
    validationErrors,
    execute,
    getError,
    validationResult,
    clearError,
  }
}
